(function () {
  const STORAGE_KEY = 'kk2_wishlist_v1';

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(
      new CustomEvent('kk2:wishlist:change', { detail: { count: list.length, list } })
    );
  }

  function isInWishlist(productId) {
    return getWishlist().some((item) => String(item.id) === String(productId));
  }

  function toggle(productId, meta) {
    const list = getWishlist();
    const idx = list.findIndex((item) => String(item.id) === String(productId));
    let added;
    if (idx > -1) {
      list.splice(idx, 1);
      added = false;
    } else {
      list.push({
        id: String(productId),
        handle: meta && meta.handle ? meta.handle : null,
        addedAt: Date.now(),
      });
      added = true;
    }
    saveWishlist(list);
    return added;
  }

  function syncButtons() {
    const list = getWishlist();
    const ids = new Set(list.map((i) => String(i.id)));
    document.querySelectorAll('[data-kk2-wishlist-toggle]').forEach((btn) => {
      const pid = btn.getAttribute('data-kk2-wishlist-toggle');
      btn.classList.toggle('is-active', ids.has(String(pid)));
      btn.setAttribute('aria-pressed', ids.has(String(pid)) ? 'true' : 'false');
    });
    document.querySelectorAll('[data-kk2-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-kk2-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const pid = btn.getAttribute('data-kk2-wishlist-toggle');
    const handle = btn.getAttribute('data-kk2-wishlist-handle');
    const added = toggle(pid, { handle });
    btn.classList.toggle('is-active', added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.classList.add('kk2-pulse');
    setTimeout(() => btn.classList.remove('kk2-pulse'), 300);
  });

  document.addEventListener('kk2:wishlist:change', syncButtons);
  document.addEventListener('DOMContentLoaded', syncButtons);

  window.KK2Wishlist = {
    get: getWishlist,
    isInWishlist,
    toggle,
    clear: function () {
      saveWishlist([]);
    },
    remove: function (productId) {
      const list = getWishlist().filter((i) => String(i.id) !== String(productId));
      saveWishlist(list);
    },
    fetchProducts: async function () {
      const list = getWishlist();
      const results = await Promise.all(
        list.map(async (item) => {
          if (!item.handle) return null;
          try {
            const res = await fetch(`/products/${item.handle}.js`);
            if (!res.ok) return null;
            return await res.json();
          } catch (e) {
            return null;
          }
        })
      );
      return results.filter(Boolean);
    },
  };

  syncButtons();
})();
